import { useQuery } from 'react-query';
import { SetupIntent, Stripe } from '@stripe/stripe-js';

import { ErrorResponse } from 'legacy/common/utils/error';
import { getInstance } from 'legacy/common/utils/stripe';

async function getSetupIntent(
  stripe: Stripe,
  setupIntentSecret: string
): Promise<SetupIntent> {
  const { setupIntent, error: stripeError } = await stripe.retrieveSetupIntent(
    setupIntentSecret
  );

  if (stripeError) {
    throw new Error(stripeError.message);
  }

  return setupIntent;
}

function useGetStripeSetupIntent(
  setupIntentId: string,
  setupIntentSecret: string
) {
  const stripe = getInstance();

  return useQuery<SetupIntent, ErrorResponse>(
    ['stripe/setup-intent', setupIntentId],
    () => getSetupIntent(stripe, setupIntentSecret),
    {
      enabled: !!setupIntentId && !!setupIntentSecret && !!stripe
    }
  );
}

export default useGetStripeSetupIntent;
